import { useEffect, useRef } from "react";

/** Focus on entry without opting the control into the browser's autofocus focus-visible state. */
export function useInitialFocus<T extends HTMLElement>(active = true) {
  const ref = useRef<T>(null);

  useEffect(() => {
    if (active) ref.current?.focus({ preventScroll: true });
  }, [active]);

  return ref;
}
